export default {
  errors: [],
  successes: [],
  maxErrors: 5,
  maxSuccesses: 5,
  globalLoading: false,
  selectedCompany: {},
  dateConfig: {
    disableMobile: true,
    altInput: true,
    altFormat: 'd-m-Y',
    dateFormat: 'Y-m-d',
    weekNumbers: true,
    locale: {
      firstDayOfWeek: 1,
    },
    altInputClass: 'form-control position-relative form-control input flatpickr-date-input',
  },
  dateTimeConfig: {
    disableMobile: true,
    altInput: true,
    altFormat: 'd-m-Y H:i',
    dateFormat: 'Y-m-d H:i:S',
    weekNumbers: true,
    locale: {
      firstDayOfWeek: 1,
    },
    enableTime: true,
    altInputClass: 'form-control position-relative form-control input flatpickr-date-input',
  },
  companyFilters: null,
  projectFilters: null,
  actionFilters: null,
  journalRecordFilters: null,
  contactFilters: null,
  draftArticleFilters: null,
  version: null,
  build: null,
  appUpdated: false,
  filters: {},
  presence: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/common/state.js